import React from 'react';
import { connect } from 'react-redux';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
import ApiOutputExample from '../components/apiOutputExample/ApiOutputExample';

// //components
import widgetsImage from '../media/aircheckr-widget-variations.jpg';
// import SignupButton from '../components/signupbutton/SignupButton';
//styles
import './developers.styl';
import 'bootstrap/dist/css/bootstrap.css';
import '../../ext/font-awesome-4.7.0/css/font-awesome.css';
//media
//import header_icon from '../media/aircheckr-dev.png';
//import img_big from '../media/industry/ho.png';
//text
import { PageText as PageTextEN, Categories as CategoriesEN, apiOutputExample } from '../input-text/en/developers_page';
import { PageText as PageTextNL, Categories as CategoriesNL } from '../input-text/nl/developers_page';

class Developers extends React.Component {
  constructor(props) {
    super(props);
    this.setLocale = this.setLocale.bind(this);
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://widget.aircheckr.com/js/client.widget.js';
    script.async = true;

    document.body.appendChild(script);
  }

  componentWillMount() {
      switch (this.props.lang) {
          case 'nl':
              this.props.setLocale(this.props.lang, true);
              break;
          default: this.props.setLocale(this.props.locale, true);
      }
  }

  componentWillUnmount() {
      this.props.setLocale(this.props.locale, false);
  }

  setLocale(locale) {
      this.PageText = null;
      this.Categories = null;
      switch (this.props.locale) {
          case 'en':
              this.PageText = PageTextEN;
              this.Categories = CategoriesEN;
              break;
          case 'nl':
              this.PageText = PageTextNL;
              this.Categories = CategoriesNL;
              break;
          default:
              this.PageText = PageTextEN;
              this.Categories = CategoriesEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <i className="fa fa-code fa-5x developers-icon" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{this.PageText._1}</h1>
            <p>{this.PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ this.Categories._1 } />
        <CategoryContainer
          cols='1'
          category={ this.Categories._2 }
          component={ <ApiOutputExample apiOutput={ apiOutputExample } /> } />
        <CategoryContainer cols='1' category={ this.Categories._3 } component={ 
          <div>
            <article
              className="ac-aircheckr-widget"
              data-theme="dark"
              data-locale={ this.props.locale === 'en' ? 'en_GB' : 'nl_BE' }
              data-type="extended"
              data-level="street"
              data-default-location="Grote Markt 1, 2000 Antwerpen"
              data-token="eyJhbGciOiJIUzI1NiJ9.NWNiMmUwNjAtYTJiMC0xMWU3LTgwNjYtNmI2ZTg4ZGUwNGU5.o3wnCw4DXe9L7K_MkhuJr7q5wT8DzYOvedBwJkAnL8I"
            >
            </article>
            <article
              className="ac-aircheckr-widget"
              data-theme="light"
              data-locale={ this.props.locale === 'en' ? 'en_GB' : 'nl_BE' }
              data-type="extended"
              data-level="street"
              data-default-location="Grote Markt 1, 2000 Antwerpen"
              data-token="eyJhbGciOiJIUzI1NiJ9.NWNiMmUwNjAtYTJiMC0xMWU3LTgwNjYtNmI2ZTg4ZGUwNGU5.o3wnCw4DXe9L7K_MkhuJr7q5wT8DzYOvedBwJkAnL8I"
            >
            </article>
          </div> 
        }/>
        <CategoryContainer cols='1' category={ this.Categories._4 } />
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Developers);



// WEBPACK FOOTER //
// ./src/routes/Developers.js